import { ActionTree } from "vuex";
import * as types from "@/store/constants/setting_types";
import { GETTER_MASTER_USER_ID } from "@/store/constants/index_types";
import Jsbridge from "@/jsbridge/index";
import { getSettingData } from "@/api/cg/service/setting_service";
import Localize from "@/services/payment/localize";

const actions: ActionTree<any, any> = {
  // 拉取线上setting数据并更新, 传入需要拉取的setting部分
  async [types.UPDATE_GX_SETTING_DATA]({ commit, getters }: any, payload: any) {
    try {
      const { module_name, keys } = payload;
      // 拉取需要的线上setting
      const masterId = getters[GETTER_MASTER_USER_ID];
      const setting = await getSettingData(masterId, keys);
      Localize.update(setting);
      commit(types.UPDATE_GX_SETTING_DATA, {
        [module_name]: setting
      });
      return setting;
    } catch (error) {
      //
      return Promise.reject(error);
    }
  }
};

export default actions;
